import http from '@/plugins/axios/axios';

export default class ConcluirFecharPeriodoService {

    concluirFecharPeriodo(requisicao) {       
        return http.post('/api/concluir-fechar-periodo/conluir', requisicao);
    }

}